import { render, staticRenderFns } from "./TournamentShare.vue?vue&type=template&id=2b13fdd8&scoped=true"
import script from "./TournamentShare.vue?vue&type=script&lang=js"
export * from "./TournamentShare.vue?vue&type=script&lang=js"
import style0 from "./TournamentShare.vue?vue&type=style&index=0&id=2b13fdd8&prod&lang=scss&scoped=true"
import style1 from "./TournamentShare.vue?vue&type=style&index=1&id=2b13fdd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b13fdd8",
  null
  
)

export default component.exports